var _circle, _path, _path2, _path3, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTanzania(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#ffda44",
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m74.98 437.02c10.739 10.739 22.197 20.316 34.216 28.748l356.57-356.571c-8.43-12.019-18.008-23.477-28.747-34.216-10.74-10.739-22.197-20.315-34.216-28.747l-356.569 356.571c8.43 12.016 18.008 23.475 28.746 34.215z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m74.98 74.98c-80.762 80.764-96.267 202.055-46.544 298.398l344.942-344.941c-96.343-49.723-217.635-34.217-298.398 46.543z",
    fill: "#6da544"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m437.019 437.02c80.762-80.762 96.266-202.055 46.545-298.398l-344.942 344.942c96.341 49.723 217.634 34.218 298.397-46.544z",
    fill: "#338af3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTanzania);
export default __webpack_public_path__ + "static/media/tanzania.3760828de47bedb6955743ea8b6988a2.svg";
export { ForwardRef as ReactComponent };